require('./referralsInvitationsStateFilter.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @Commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { formatText } = require('core/i18n').i18n;

//@constants
const {
    REFERRALS_INVITATIONS_FILTER_STATE_ALL,
    REFERRALS_INVITATIONS_FILTER_STATE_PENDING,
    REFERRALS_INVITATIONS_FILTER_STATE_USED,
    REFERRALS_INVITATIONS_FILTER_STATE_PAID
} = require('constants/index');

const options = [
    REFERRALS_INVITATIONS_FILTER_STATE_ALL,
    REFERRALS_INVITATIONS_FILTER_STATE_PENDING,
    REFERRALS_INVITATIONS_FILTER_STATE_USED,
    REFERRALS_INVITATIONS_FILTER_STATE_PAID
];

class ReferralsInvitationsStateFilter extends React.Component {
    constructor(props) {
        super(props);
        const { immFilter } = this.props;

        this.state = {
            selected: immFilter.get('selected')
        };

        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    handleFilterChange(el) {
        const value = el.value;
        const selected = value === REFERRALS_INVITATIONS_FILTER_STATE_ALL.toUpperCase() ? '' : value;
        this.props.onChangeSelected(selected);
        this.setState({
            selected
        });
    }

    render() {
        const selectedValue = this.state.selected ? this.state.selected : REFERRALS_INVITATIONS_FILTER_STATE_ALL.toUpperCase();
        const selectionOptions = options.map((index) => {
                const label = formatText(`filterReferralsInvitationsState-${index}`);
                return {
                    label,
                    value: index.toUpperCase()
                }
            });
        
        return (
            <div className="referrals-invitations-state-filter">
                <h3 className="referrals-invitations-state-filter__title">
                    <FormattedText value="filterReferralsInvitationsState-title" />
                </h3>
                <div className="row">
                    <div className="col-xs-6">
                        <OKSelect
                            name="referrals-invitations-status-dropdown"
                            onChange={this.handleFilterChange}
                            value={selectedValue}
                            options={selectionOptions}
                            searchable={false}
                            clearable={false}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

ReferralsInvitationsStateFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onChangeSelected: PropTypes.func
};

ReferralsInvitationsStateFilter.defaultProps = {
    onChangeSelected: () => { }
};

module.exports = ReferralsInvitationsStateFilter;
